import {
  foreignKey,
  integer,
  numeric,
  pgEnum,
  pgTable,
  text,
  timestamp,
  unique,
  uuid
} from 'drizzle-orm/pg-core';

import { applications } from './applications';
import { candidates } from './candidates';
import { interviewQuestions, questionCategoryEnum } from './interviews';
import { interviewSessions } from './interview-sessions';
import { jobs } from './jobs';
import { organizations } from './organizations';
import { tenantOrgIsolationPolicy } from './rls';
import { SCORING_RECOMMENDATION } from '@kiku/config/constants';

import { tenants } from './tenants';

export const scoringStatusEnum = pgEnum('scoring_status', [
  'pending',
  'processing',
  'completed',
  'failed'
]);

export const recommendationEnum = pgEnum('recommendation', SCORING_RECOMMENDATION);

export const interviewScores = pgTable(
  'interview_scores',
  {
    id: uuid('id').primaryKey().defaultRandom(),
    tenantId: uuid('tenant_id')
      .notNull()
      .references(() => tenants.id),
    orgId: uuid('org_id')
      .notNull()
      .references(() => organizations.id),
    sessionId: uuid('session_id')
      .notNull()
      .references(() => interviewSessions.id),
    applicationId: uuid('application_id')
      .notNull()
      .references(() => applications.id),
    candidateId: uuid('candidate_id')
      .notNull()
      .references(() => candidates.id),
    jobId: uuid('job_id')
      .notNull()
      .references(() => jobs.id),
    status: scoringStatusEnum('status').notNull().default('pending'),
    overallScore: integer('overall_score'),
    recommendation: recommendationEnum('recommendation'),
    eligibilityPassed: text('eligibility_passed'),
    expectationsPassed: text('expectations_passed'),
    assessmentAverage: numeric('assessment_average'),
    aiSummary: text('ai_summary'),
    scoredAt: timestamp('scored_at'),
    errorMessage: text('error_message'),
    createdAt: timestamp('created_at').notNull().defaultNow(),
    updatedAt: timestamp('updated_at')
      .notNull()
      .defaultNow()
      .$onUpdateFn(() => new Date())
  },
  (t) => [unique('interview_scores_session_id').on(t.sessionId), tenantOrgIsolationPolicy()]
).enableRLS();

export const interviewQuestionScores = pgTable(
  'interview_question_scores',
  {
    id: uuid('id').primaryKey().defaultRandom(),
    tenantId: uuid('tenant_id')
      .notNull()
      .references(() => tenants.id),
    orgId: uuid('org_id')
      .notNull()
      .references(() => organizations.id),
    interviewScoreId: uuid('interview_score_id').notNull(),
    questionId: uuid('question_id')
      .notNull()
      .references(() => interviewQuestions.id),
    category: questionCategoryEnum('category').notNull(),
    questionText: text('question_text').notNull(),
    verdict: text('verdict'),
    score: integer('score'),
    reasoning: text('reasoning').notNull(),
    evidence: text('evidence').notNull(),
    competencyName: text('competency_name'),
    createdAt: timestamp('created_at').notNull().defaultNow()
  },
  (t) => [
    foreignKey({
      columns: [t.interviewScoreId],
      foreignColumns: [interviewScores.id],
      name: 'iq_scores_interview_score_id_fk'
    }),
    tenantOrgIsolationPolicy()
  ]
).enableRLS();
